import { render } from "./HelpPageTemplate.vue?vue&type=template&id=612cfd92"
import script from "./HelpPageTemplate.vue?vue&type=script&lang=js"
export * from "./HelpPageTemplate.vue?vue&type=script&lang=js"

import "./HelpPageTemplate.vue?vue&type=style&index=0&id=612cfd92&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__